import {
  FormControlLabel,
  Checkbox,
  FormGroup,
  FormHelperText,
  Text,
  Card,
  CardHeader,
  CardContent,
  Inline,
  Stack,
} from "@digitalreality/ui";
import { getDealersAsync } from "../../Services/ProjectsService";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import React from "react";
import { Dealer } from "../../Models/Dealer";
import { ProjectFormData } from "../../Models/ProjectFormData";
import { useAppState } from "../../StateStore/Store";
import { RestApiResponse } from "../../Models/RestApiResponse";
import { useTranslation } from "react-i18next";
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

type GroupedDealers = {
  LeicaDealers: Dealer[];
  PrinothDealers: Dealer[];
  Others: Dealer[];
};

export default function Access({ onSubmit, formRef }: any) {
  const { t } = useTranslation();
  const [selectedDealers, setSelectedDealers] = useState<string[]>([]);
  const [noDealersError, setNoDealersError] = useState<string>("");
  const [groupedDealers, setGroupedDealers] = useState<GroupedDealers>({
    LeicaDealers: [],
    PrinothDealers: [],
    Others: [],
  });
  const { state } = useAppState();

  const { handleSubmit } = useForm({
    defaultValues: state.projectModal.project,
  });

  const onLocalSubmit = (data: ProjectFormData) => {
    if (selectedDealers.length > 0) {
      data.dealerIds = selectedDealers;
    } else {
      return;
    }

    return onSubmit(data);
  };

  useEffect(() => {
    const apiDealersList = () => {
      console.log("api dealers list is called:");
      getDealersAsync().then((response: RestApiResponse) => {
        if (response.success) {
          setSelectedDealers(
            state.projectModal.project?.dealerIds
              ? state.projectModal.project.dealerIds
              : []
          );
          var grouped: GroupedDealers = {
            LeicaDealers: [],
            PrinothDealers: [],
            Others: [],
          };
          response.data.map((dealer: Dealer) => {
            if (dealer.name.includes("Leica")) {
              grouped.LeicaDealers.push(dealer);
            } else if (dealer.name.includes("Prinoth")) {
              grouped.PrinothDealers.push(dealer);
            } else {
              grouped.Others.push(dealer);
            }
          });

          grouped.LeicaDealers.sort((a, b) => (a.name > b.name ? 1 : -1));
          grouped.PrinothDealers.sort((a, b) => (a.name > b.name ? 1 : -1));
          grouped.Others.sort((a, b) => (a.name > b.name ? 1 : -1));
          setGroupedDealers(grouped);
        } else {
          const errorCode = response.errorCode
            ? t("Texts." + response.errorCode)
            : t("Texts.NoDealersValidation");
          setNoDealersError(errorCode);
        }
      });
    };

    apiDealersList();
  }, []);

  const handleOnChange = (event: any) => {
    var values: string[] = [...selectedDealers];
    var value: string = event.target.value;
    var index = values.indexOf(value);

    if (index > -1) {
      values.splice(index, 1);

      setSelectedDealers([...values]);
    } else {
      setSelectedDealers([...values, value]);
    }
  };

    return (
        <form
            id="access"
            onSubmit={handleSubmit(onLocalSubmit)}
            ref={formRef}
            autoComplete="off">
            <FormGroup>
                <Inline sx={{ width: "1292px", overflow: 'auto'}} gap={2}>
                    <Card sx={{ height: "538px", width: "450px", p: 0}}>
                        <CardHeader title="Leica" />
                        <Divider />
                        <CardContent sx={{ height: "100%", overflow: "scroll" }}>
                            {groupedDealers.LeicaDealers.map((dealer) => { return (
                                <Stack gap={5} key={"Leica_" + dealer.id}>
                                    <FormControlLabel
                                        key={dealer.id}
                                        control={
                                            <Checkbox
                                                value={dealer.id}
                                                onChange={handleOnChange}
                                                checked={selectedDealers.includes(dealer.id) || dealer.name == "Leica BU"}
                                                disabled={dealer.name == "Leica BU"}/>
                                        }
                                        label={dealer.name}/>
                                </Stack>
                            )})}
                        </CardContent>
                    </Card>
                    <Card sx={{ height: "538px", width: "450px", p: 0}}>
                        <CardHeader title="Prinoth" />
                        <Divider />
                        <CardContent sx={{ height: "100%", overflow: "scroll" }}>
                            {groupedDealers.PrinothDealers.map((dealer) => { return (
                                <Stack gap={5} key={"Prinoth_" + dealer.id}>
                                    <FormControlLabel
                                        key={dealer.id}
                                        control={
                                            <Checkbox
                                                value={dealer.id}
                                                onChange={handleOnChange}
                                                checked={selectedDealers.includes(dealer.id)}/>
                                        }
                                        label={dealer.name}/>
                                </Stack>
                            )})}
                        </CardContent>
                    </Card>
                    <Card sx={{ height: "538px", width: "450px", p: 0}}>
                        <CardHeader title={t("Texts.DealersAndPartners")} />
                        <Divider />
                        <CardContent sx={{ height: "100%", overflow: "scroll" }}>
                            {groupedDealers.Others.map((dealer) => { return (
                                <Stack gap={5} key={"Others_" + dealer.id}>
                                    <FormControlLabel
                                        key={dealer.id}
                                        control={
                                            <Checkbox
                                                value={dealer.id}
                                                onChange={handleOnChange}
                                                checked={selectedDealers.includes(dealer.id)}/>
                                        }
                                        label={dealer.name}/>
                                </Stack>
                            )})}
                        </CardContent>
                    </Card>
                </Inline>
            </FormGroup>
            <Typography sx={{ mt: selectedDealers.length === 0 ? '5px' : '18px', mb: '0'}} style={{ fontSize: '12px', color: "#888888" }}>{t("Texts.AccessTabDealersMessage")}</Typography>
            {selectedDealers.length === 0 && (
                <FormHelperText
                    error={selectedDealers.length === 0}
                    sx={{ mb: "0" }}>
                    {noDealersError ? noDealersError : "*" + t("Texts.SelectDealerValidation")}
                </FormHelperText>
            )}
        </form>
    );
}
